import React from 'react';
import Modal from '../../Modal';
import Button from '../../Button';
import RadioInput from '../../Radio/RadioInput';
import { useTranslation } from 'react-i18next';

export default function PrintModal(props) {
  const {isOpen, handleClose, includeActivityLog, setIncludeActivityLog, printLocale, setPrintLocale} = props;

  const {t} = useTranslation("parent_report");

  const handleToggleActivityLog = () => {
    setIncludeActivityLog(!includeActivityLog);
  };

  const handlePrint = () => {
    return props.handlePrint();
  };

  return (
    <Modal isOpen={isOpen} renderCloseIcon={false} onClose={handleClose}>
      <div className='dyslexiaPrintModal'>
        <div className='modalContent'>
          <div className='modalTitle'>
            {t("Print Parent Letters")}
          </div>
          <div className='inputGroup'>
            <div>{t("select_optional_attachments")}:</div>
            <div className='attachmentOption' onClick={handleToggleActivityLog}>
              <input type='checkbox' readOnly className='attachmentCheckbox' checked={includeActivityLog} />
              {t("Home Activity Log")}
            </div>
          </div>
          <div className='inputGroup'>
            <div>{t("Print letter in")}:</div>
            <RadioInput 
              label={t("common:English")}
              value="en-us"
              checked={printLocale==="en-us"}
              onClick={() => setPrintLocale("en-us")} 
            />
            <RadioInput 
              label={t("common:Spanish")}
              value="es-mx"
              checked={printLocale==="es-mx"}
              onClick={() => setPrintLocale("es-mx")} 
            />       
          </div>
        </div>
        <div className='modalControls'>
          <Button onClick={handlePrint}>{t("common:Print")}</Button>
          <Button type='secondary' onClick={handleClose}>{t("common:Cancel")}</Button>
        </div>
      </div>
    </Modal>
  );
}